exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#menuDropDown[data-v-79e5bda1]{width:100%;position:absolute;right:0;overflow-x:hidden;transform:translateY(-100%);transition:1s;text-align:center;line-height:3rem;box-shadow:-6px 12px 12px 2px rgba(0,0,0,.26);z-index:-10}#menuDropDown.show-menu[data-v-79e5bda1]{transform:translateY(0);transition:1s}li[data-v-79e5bda1]{margin:10% 0}@media only screen and (min-width:700px){#menuDropDown[data-v-79e5bda1]{width:40%}}", ""]);

// exports
